export const UPDATE_AUTH_STATE = 'UPDATE_AUTH_STATE'
export const UPDATE_USER = 'UPDATE_USER'
export const USER_LOGOUT = 'LOGOUT'
